export const scrollToFirstInvalidElement = () => {
  const el: Element | null = document.querySelector(".p-invalid")

  if (el) {
    const { top } = el.getBoundingClientRect()
    window.scrollTo(0, window.scrollY + top)
  }
}
